import { useField } from "formik";
import { Link } from "react-router-dom";

const RegistrationTerms = () => {
	const [field, meta] = useField({ name: "terms", type: "checkbox" });
	const invalid = Boolean(meta.touched && meta.error);
	return (
		<div className="auth-terms">
			<label htmlFor="auth-terms">
				<input {...field} id="auth-terms" type="checkbox" aria-invalid={invalid} aria-describedby={invalid ? "auth-terms-error" : undefined} />
				<span>I have read the <Link to="/terms-and-conditions" tabIndex={0} target="_blank" rel="noopener noreferrer">terms and conditions</Link>.</span>
			</label>
			{invalid && <p id="auth-terms-error" className="auth-field__error" role="alert">{meta.error}</p>}
		</div>
	);
};

export default RegistrationTerms;
